"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESubNbOperationsSansConseillerCorporationTrads = void 0;
exports.ESubNbOperationsSansConseillerCorporationTrads = {
    more_than_ten: "Plus de 10",
    none: "Aucune",
    one_to_five: "De 1 à 5",
    six_to_ten: "De 6 à 10",
};
